import { MocomRecyclingRequest } from "domain/RecyclingForm/MocomRecyclingRequest";
import { getAPIBase } from "util/MagnoliaAppHelpers";
import { HTTPClientService } from "./HTTPClient";

export interface MocomRecyclingMail {
  name: string;
  address: string;
  email: string;
  phone?: string;
  message?: string;
  wastes: MocomRecyclingRequest[];
  _altcha: string;
}

const basePath = getAPIBase();
const restContactMailBase =
  basePath + process.env.REACT_APP_MGNL_API_MOCOM_WASTE_FORM;

export default class MocomRecyclingFormService {
  readonly httpClientService: HTTPClientService;

  constructor(httpClientService: HTTPClientService) {
    this.httpClientService = httpClientService;
  }

  sendMocomRecyclingFormEmail = async (mail: MocomRecyclingMail) => {
    const httpClient = this.httpClientService.getAlbisHttpClient();
    return await httpClient.post(restContactMailBase, mail);
  };
}
